import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useFieldArray, useForm } from "react-hook-form";
import classNames from "classnames";
library.add(fas);

const EditOffCanvance = (props) => {
  const id = props.show;
  const { postData, getData, IMG_URL, getDimension } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const GetEditData = async () => {
    const response = await getData(`/masters/category/${id}`);
    reset(response?.data);
    // setImagePreview(IMG_URL + response?.data?.image);
  };
  useEffect(() => {
    GetEditData();
  }, []);

  const [countLang, setCountLang] = useState([]);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,getValues,
  } = useForm({
    defaultValues: {
      languages: [], // start empty
    },
  });

  const { fields } = useFieldArray({
    control,
    name: "languages",
  });

  const getLanguges = async () => {
    const response = await getData("/all-languages");
    setCountLang(response.data);

    reset({
      languages: response.data.map((lang) => ({
        language_id: lang.id,
        name: "",
      })),
    });
  };

  useEffect(() => {
    getLanguges();
  }, []);

  const onSubmit = async (data) => {
    try {
      const formData = new FormData();

      formData.append("languages", JSON.stringify(data.languages));

      const response = await postData(`/masters/category/${id}`, formData);
      console.log(response);
      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };


  console.log(getValues(),"getValues getValues");
  
  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="edit-modal-holder"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit Category
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
            <Row className="">
              {fields.map((field, index) => (
                <Col md={12} key={field.id}>
                  <div className="main-form-section mt-5">
                    <Row className="justify-content-center">
                      <Form.Label column sm={3}>
                        Name ({countLang[index]?.name})
                      </Form.Label>
                      <Col sm={6}>
                        <Form.Group>
                          <InputGroup>
                            <Form.Control
                              type="text"
                              placeholder={`Enter Name in ${countLang[index]?.name}`}
                              className="input-mandatory"
                              {...register(`languages.${index}.name`, {
                                required: `Name is required in ${countLang[index]?.name}`,
                              })}
                            />
                          </InputGroup>
                          {errors.languages?.[index]?.name && (
                            <span className="text-danger">
                              {errors.languages[index].name.message}
                            </span>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                </Col>
              ))}

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
